export default __webpack_public_path__ + "images/DG.dcb44b9.png";